import { render, staticRenderFns } from "./quotationCompany.vue?vue&type=template&id=715169aa&scoped=true"
import script from "./quotationCompany.vue?vue&type=script&lang=js"
export * from "./quotationCompany.vue?vue&type=script&lang=js"
import style0 from "./quotationCompany.vue?vue&type=style&index=0&id=715169aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715169aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('715169aa')) {
      api.createRecord('715169aa', component.options)
    } else {
      api.reload('715169aa', component.options)
    }
    module.hot.accept("./quotationCompany.vue?vue&type=template&id=715169aa&scoped=true", function () {
      api.rerender('715169aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createQuotation/quotationCompany.vue"
export default component.exports